<div class="manage-my-ads" fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="start stretch" *ngIf="taxonomy">
  <h4>Manage Listings <button type="button" mat-flat-button [color]="'primary'"
      [routerLink]="['/dashboard', {outlets:{dashboardOutlet:'admin-listings-management-dashboard'}}]"
      *ngIf="userId">Clear Search</button></h4>
  <div class="filter-div" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center">
    <form [formGroup]="search" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
      <input fxFlex="60" type="text" placeholder="Search" formControlName="searchText" />
      <select fxFlex="20" formControlName="propertyType">
        <option value="null" checked="true">Show All</option>
        <option value="1">Multifamily</option>
        <option value="2">Office</option>
        <option value="3">Retail</option>
        <option value="4">Industrial</option>
        <option value="5">Hospitality</option>
        <option value="6">Specialty</option>
        <option value="7">Land</option>
        <option value="8">Businesses</option>
      </select>
      <select fxFlex="20" formControlName="listingStatus">
        <option value="1" checked="true">Approved</option>
        <option value="2">In Active</option>
        <option value="3">Incomplete</option>
        <option value="4">Sold</option>
        <option value="5">Rented</option>
        <option value="6">Under Offer</option>
        <option value="9">Expired</option>
        <option value="10">Deleted</option>
        <option value="12">Suspended</option>
      </select>
      <button fxFlex="20" type="button" mat-flat-button [color]="'primary'" (click)="searchForListing()">Search
        Listing</button>
    </form>

  </div>
  <div *ngIf="listingData.length" fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="start stretch">
    <div *ngFor="let listing of listingData " style="width:99%;">
      <div class="manage-listing-card">
        <div fxLayout="column" fxLayoutAlign="start start">
          <div class="listing-card-inside-div" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start start">
            <ng-container *ngFor="let billingItem of listing.listingProducts;let i = index;">
              <div [class.highlighted]="billingItem.productId==4" *ngIf="billingItem.productId==4"></div>
            </ng-container>
            <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="50" style="z-index: 1;">
              <div class="image-div" fxFlex="50" fxLayout="column" fxLayoutAlign="start stretch"
                (click)="viewListingEventCalled(listing)" style="cursor: pointer;">
                <div class="image"
                  [ngStyle]="{'background-image': 'url(' + storage + '/listing/' + listing?.filePath + ')'}"></div>
                <div *ngIf="listing.listingStatus==4" fxLayout="column" fxLayoutAlign="center center"
                  style="color: red;font-size: 50px;background: #98939359;position: absolute;top: 0;bottom: 0;left: 0;right: 0;">
                  {{'SOLD'|translate}}
                </div>
                <div *ngIf="listing.listingStatus==5" fxLayout="column" fxLayoutAlign="center center"
                  style="color: red;font-size: 50px;background: #98939359;position: absolute;top: 0;bottom: 0;left: 0;right: 0;">
                  {{'RENTED'|translate}}
                </div>
                <div *ngIf="listing.listingStatus==12" fxLayout="column" fxLayoutAlign="center center"
                  style="color: red;font-size: 50px;background: #98939359;position: absolute;top: 0;bottom: 0;left: 0;right: 0;">
                  {{'SUSPENDED'|translate}}
                </div>
                <div *ngIf="listing.listingStatus==11" fxLayout="column" fxLayoutAlign="center center"
                  style="color: red;font-size: 50px;background: #98939359;position: absolute;top: 0;bottom: 0;left: 0;right: 0;">
                  {{'UNDER REVIEW'|translate}}
                </div>
                <ng-container *ngFor="let billingItem of listing.listingProducts;let i = index;">

                  <div class="top-banner" *ngIf="billingItem.productId==1">
                    {{billingItem?.bannerText}}
                  </div>
                  <div class="digonal-banner" *ngIf="billingItem.productId==2">
                    {{billingItem?.bannerText}}
                  </div>
                  <div class="bottom-banner" *ngIf="billingItem.productId==3">
                    {{billingItem?.bannerText}}
                  </div>


                </ng-container>
              </div>
              <ng-container *ngFor="let billingItem of listing.listingProducts;let i = index;">
                <span style="color: #f44336; padding: 10px;font-weight:bold;"
                  *ngIf="billingItem.isCustomBannerText">CUSTOM BANNER</span>
              </ng-container>
              <span style="color: #f44336; padding: 10px;">From:
                {{listing.platformDescription!=''?listing.platformDescription:'ThaiComm'}}</span>
              <span style="color: #f44336; padding: 10px;">Listing Id:
                {{listing.id}}</span>
            </div>
            <div class="listing-side-body" fxFlex="50" fxLayoutGap="10px" fxLayout="column" fxLayoutAlign="start start">
              <div fxLayout="row" fxLayoutAlign="space-between start">

                <div fxFlex="80" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
                  <h5 (click)="viewListingEventCalled(listing)" style="cursor: pointer;">{{listing.title}}</h5>
                  <p (click)="viewListingEventCalled(listing)" style="cursor: pointer;"><i
                      class="mdi mdi-mdi mdi-map-marker"></i>{{listing.formattedAddress}}</p>
                </div>
                <div fxFlex="20" style="margin-top: 10px;margin-right: -33px;position: relative;">
                  <div class="round-image"
                    [ngStyle]="{
                          'background-image': listing.agentProfileImage?'url('+storage+'/user/'+listing.agentProfileImage+')': ''}"
                    (mouseenter)="listing.showInfo=true" ></div>
                  <div *ngIf="listing.showInfo" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="20px"
                  (mouseleave)="listing.showInfo = false"
                  style="position: absolute;width: 500px;background: #8cc63f;padding: 20px;right: -90px;top: 69px;color:white;z-index: 9;">
                    <div class="arrow-up"></div>
                    <div>Name: {{listing.agentFirstName}} {{listing.agentLastName}}</div>
                    <div>Phone: {{listing.agentPhoneNumber}}</div>
                    <div fxLayout="row" fxLayoutAlign="start space-between" fxLayoutGap="20px">
                      <div>Email: {{listing?.agentEmail}} </div> <a (click)="copy(listing?.agentEmail)"
                        style="color:white;">Copy Email</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-div" fxLayout="row" fxLayoutAlign="space-between start" *ngIf="listing?.propertyType">
                <div>Category</div>
                <div mat-flat-button (click)="openPropertypeChangeDialog(listing)" style="cursor: pointer;text-align: center;padding: 5px;width: 163px;background: #8cc63f;color: white;border-radius: 2px;">
                  Add more category</div>
                <!-- <span >{{getEnumById('propertyType',listing?.propertyType,false).name}}</span> -->
                <div class="text-div-right-text" style="background:#8cc63f; color:white;">
                  <button color="primary" mat-icon-button [matMenuTriggerFor]="menu"><i class="mdi mdi-pencil"
                      style="color:white;"></i></button>
                  <span [matMenuTriggerFor]="menu"
                    style="cursor: pointer;">{{getEnumById('propertyType',null,listing?.propertyType,false).name}}</span>
                  <mat-menu #menu="matMenu" class="propertyTypeMenu">
                    <mat-list role="list" style="padding: 20px;max-width:600px;width:600px;" fxLayout="row wrap"
                      fxLayoutAlign="space-between center">
                      <mat-list-item *ngFor="let item of taxonomy.propertyTypeResidentialType"
                        (click)="updatePropertyTypeListing(listing.id,item)" style="cursor: pointer;">{{item.name}}
                      </mat-list-item>
                      
                    </mat-list>
                  </mat-menu>
                </div>
              </div>
              <div class="text-div" fxLayout="row" fxLayoutAlign="space-between start" *ngIf="listing?.residentialType||selectedPropertyType?.sub?.length">
                <div>Type</div>
                <!-- <span 
                    *ngIf="listing?.residentialType">{{getEnumById('residentialType',listing?.residentialType,false).name}}</span> -->
                <div class="text-div-right-text" style="background:#8cc63f; color:white;">
                  <button color="primary" mat-icon-button [matMenuTriggerFor]="menu1" [matMenuTriggerFor]="menu1"><i
                      class="mdi mdi-pencil" style="color:white;"></i></button>
                  <span [matMenuTriggerFor]="menu1" style="cursor: pointer;"
                    *ngIf="listing?.residentialType">{{getEnumById('residentialType',null,listing?.residentialType,false).name}}</span>
                  <mat-menu #menu1="matMenu" class="subPropertyTypeMenu">
                    <mat-list role="list" style="padding: 20px;max-width:600px;width:600px;" fxLayout="row wrap"
                      fxLayoutAlign="space-between center">
                      <mat-list-item *ngFor="let item of selectedPropertyType?.sub"
                        (click)="updateResidentialTypeListing(listing.id,item)" style="cursor: pointer;">{{item.name}}
                      </mat-list-item>
                      
                    </mat-list>

                  </mat-menu>
                </div>
              </div>
              <div class="text-div" fxLayout="row" fxLayoutAlign="space-between start" *ngIf="listing?.listingAdditionalTypes.length">
                <div>See more categories</div>
                <div class="text-div-right-text"  style="position: relative;"
                  (mouseenter)="listing.showAdditionalTypes=true" (mouseleave)="listing.showAdditionalTypes = false">
                  <span>{{listing?.listingAdditionalTypes.length}}</span>
                  <div class="additionaltypes" *ngIf="listing.showAdditionalTypes">
                    <div *ngFor="let item of listing?.listingAdditionalTypes">
                      {{getEnumById('propertyType',null,item.propertyType,false).name}}-{{getEnumById('residentialType',null,item?.residentialType,false).name}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-div" fxLayout="row" fxLayoutAlign="space-between start" *ngIf="listing?.propertySize">
                <div>Usable Area (sm)</div>
                <div class="text-div-right-text">{{listing?.propertySize | number: '1.0-0'}}</div>
              </div>
              <div class="text-div" fxLayout="row" fxLayoutAlign="space-between start" *ngIf="listing?.numUnits">
                <div>#Units/Rooms</div>
                <div class="text-div-right-text">{{listing?.numUnits | number: '1.0-0'}}</div>
              </div>
              <div class="text-div" fxLayout="row" fxLayoutAlign="space-between start"
                *ngIf="listing?.propertySize&&listing?.price">
                <div>Price/SqM (baht)</div>
                <div class="text-div-right-text">{{listing?.price/listing?.propertySize | number: '1.0-0'}}</div>
              </div>
              <div class="text-div" fxLayout="row" fxLayoutAlign="space-between start"
               >
                <div>Share</div>
                <div class="text-div-right-text">
                  <a class="report-share" (click)="openShareDialog(listing)" fxShow fxHide.xs fxHide.gt-xs fxHide.sm
                        fxShow.gt-sm fxShow.md fxShow.gt-md fxShow.lg fxShow.gt-lg><i class="mdi mdi-share-variant"></i>
                        {{'Share ad'|translate}}
                    </a>
                </div>
              </div>
            </div>
          </div>
          <div class="listing-card-price" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="space-between start"
            style="margin-top:10px;">
            <div fxFlex="30" fxLayout="column" fxLayoutAlign="start start">
              <p *ngIf="listing?.createdAt">Date Listed {{listing?.createdAt | date }}</p>
              <div class="price" *ngIf="listing?.price">{{listing?.price | number: '1.0-0' }} THB</div>
              <div class="price" *ngIf="!listing?.price">Price Upon Request</div>
            </div>
            <div fxFlex="70" fxLayout="row" fxLayoutGap="20px" style="padding-right: 10px;"
              fxLayoutAlign="space-between center">

              <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">
                <button mat-flat-button [color]="'primary'" style="width: 100px;margin-right:10px;"
                  (click)="viewListingEventCalled(listing)">View</button>
                <button mat-flat-button [color]="'primary'" style="width: 100px;margin-right:10px;"
                  (click)="approveOrSuspend(listing.id,1)">Active</button>
                <button mat-flat-button [color]="'primary'" style="width: 100px;"
                  (click)="approveOrSuspend(listing.id,12)">Suspend</button>
                <button mat-flat-button [color]="'primary'" style="margin-left:10px;width: 100px;"
                  (click)="edit(listing.id)">Edit</button>
                <button mat-flat-button [color]="'primary'" style="margin-left:10px;width: 100px;"
                  (click)="deleteEventCalled(listing.id)">Delete</button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- <div fxLayout="row" fxLayoutAlign="center center" style="width:100%;">
      <div fxLayout="row" fxLayoutAlign="center center">
        <ul *ngIf="numberOfpage.pages && numberOfpage.pages.length" class="pagination" fxLayout="row"
          fxLayoutAlign="center center" fxLayoutGap="20px">
          <li [ngClass]="{disabled:numberOfpage.currentPage === 1}">
            <a (click)="onClickPage(1)">First</a>
          </li>
          <li [ngClass]="{disabled:numberOfpage.currentPage === 1}">
            <a (click)="onClickPage(numberOfpage.currentPage - 1)">Previous</a>
          </li>
          <li *ngFor="let page of numberOfpage.pages" [ngClass]="{active:numberOfpage.currentPage === page}">
            <a (click)="onClickPage(page)">{{page}}</a>
          </li>
          <li [ngClass]="{disabled:numberOfpage.currentPage === numberOfpage.totalPages}">
            <a (click)="onClickPage(numberOfpage.currentPage + 1)">Next</a>
          </li>
          <li [ngClass]="{disabled:numberOfpage.currentPage === numberOfpage.totalPages}">
            <a (click)="onClickPage(numberOfpage.totalPages)">Last</a>
          </li>
        </ul>

      </div>
    </div> -->
    <td-pagination [pageInfo]="pageInfo" (pageClickEvent)="onClickPage($event)"> </td-pagination>
  </div>
  <div *ngIf="!listingData.length">
    No listing to show.
  </div>
</div>

<ng-template #viewListingDialog>
  <mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end">
      <button mat-icon-button (click)="close()"><i class="mdi mdi-close" style="font-size: 22px;"></i></button>
    </div>
    <div class="listing-div">
      <app-listing-details [listingId]="listingId"></app-listing-details>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-evenly center" style="margin-top:20px;">

      <div fxFlex></div>
      <button mat-flat-button [color]="'primary'" (click)="approveOrSuspend(listingId,1)">Approve</button>
      <button mat-flat-button (click)="approveOrSuspend(listingId,12)">Suspend</button>
      <div fxFlex></div>
      <!-- <eco-fab-speed-dial direction="left" animationMode="scale" style="margin: 10px;">
        <eco-fab-speed-dial-trigger spin="true"> -->
      <button mat-fab mat-button [color]="'primary'" [matMenuTriggerFor]="animals"><i class="mdi mdi-dots-horizontal"
          style="color:white;"></i></button>
      <mat-menu #animals="matMenu" yPosition="above">
        <button mat-menu-item style="background:white;font-size: 18px;" fxLayout="row"
          fxLayoutAlign="space-between center"> <i class="mdi mdi-delete-outline"
            style="color:black;"></i><span>Delete</span></button>
        <button mat-menu-item style="background:white;font-size: 18px;" fxLayout="row"
          fxLayoutAlign="space-between center"><i class="mdi mdi-square-edit-outline" (click)="edit()"
            style="color:black;"></i><span>Edit</span></button>
        <button mat-menu-item style="background:white;font-size: 18px;" [matMenuTriggerFor]="appMenu" fxLayout="row"
          fxLayoutAlign="space-between center">
          <i class="mdi mdi-eye-settings-outline" style="color:black;"></i>
          <span>Change Status</span>
        </button>
      </mat-menu>
      <mat-menu #appMenu="matMenu" yPosition="above">
        <button mat-menu-item (click)="approveOrSuspend(listingId,1)">Active</button>
        <button mat-menu-item (click)="approveOrSuspend(listingId,12)">Suspend</button>
      </mat-menu>

      <!-- </eco-fab-speed-dial-trigger> -->

      <!-- <eco-fab-speed-dial-actions>
          <button class="fab-button delete" mat-mini-fab style="background:white"><i class="mdi mdi-delete-outline"
              style="color:black;"></i></button>
          <button class="fab-button edit" mat-mini-fab style="background:white"><i class="mdi mdi-square-edit-outline"
              style="color:black;"></i></button>
          <button class="fab-button edit" mat-mini-fab style="background:white"
          [matMenuTriggerFor]="appMenu"><i class="mdi mdi-eye-settings-outline"
              style="color:black;"></i></button>
              <mat-menu #appMenu="matMenu">
                <button mat-menu-item>Settings</button>
                <button mat-menu-item>Help</button>
              </mat-menu>
        </eco-fab-speed-dial-actions>
      </eco-fab-speed-dial> -->
    </div>

  </mat-dialog-content>
</ng-template>
<ng-template #updatePropertyTypeDialog>
  <mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end">
      <button mat-icon-button (click)="close()"><i class="mdi mdi-close" style="font-size: 22px;"></i></button>
    </div>
    <div class="listing-div">
      <form [formGroup]="advanceSearch">
        <div class="accordion-div" *ngFor="let property of taxonomy.propertyTypeResidentialType; let i = index">
          <mat-accordion (click)="$event.stopPropagation();" *ngIf="property.id!==9&&property.id!==10"
            (change)="changeCount = changeCount + 1">
            <mat-expansion-panel>
              <mat-expansion-panel-header fxLayout="row" fxLayoutAlign="space-between center">
                <mat-panel-title>
                  <mat-checkbox color="primary" (change)="onChange($event,property)"
                    [(indeterminate)]="property.indeterminate" [value]="property.id">{{property.name}}
                  </mat-checkbox>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div *ngFor="let residential of property.sub ">
                <mat-checkbox color="primary" [value]="residential.id"
                  (change)="onChangeResident($event,[],null,property.id)"
                  [checked]="advanceSearch.get('residentialType').value.indexOf(residential.id) > -1">
                  {{residential.name}}</mat-checkbox>
              </div>

            </mat-expansion-panel>
          </mat-accordion>

        </div>

      </form>
    </div>
  </mat-dialog-content>
  <div fxLayout="row" fxLayoutAlign="center center">
    <button mat-flat-button [color]="'primary'" (click)="propertyTypeUpdated()">Update</button>
  </div>
</ng-template>

<ng-template #shareDialog>
  <mat-dialog-content>
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
          <div translate>Share To</div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
              <a href="mailto:?subject={{listing.title}}&body={{buildUrl(listing)}}"><img src="assets/images/social-icons/email.png" style="width: 98px;"/></a>
              <a (click)="shareToFb(listing)"><img src="assets/images/social-icons/facebook.png" /></a>
              <a (click)="openLineShare(listing)"> <img src="assets/images/social-icons/line.png" /></a>
              <a target="_blank"
                  href="https://twitter.com/intent/tweet?url={{buildUrl(listing)}}&text={{listing?.title}}%0A{{listing?.description?.substr(0, 50)}}%0A&hashtags=thailandcommercial"><img
                      src="assets/images/social-icons/twitter.png" /></a>
              <a target="_blank"
                  href="http://www.linkedin.com/shareArticle?mini=true&url={{buildUrl(listing)}}&title={{listing?.title}}&summary={{listing?.description?.substr(0, 50)}}&source=thailandcommercial.com"><img
                      src="assets/images/social-icons/linkedin.png" /></a>
          </div>
          
      </div>
  </mat-dialog-content>
</ng-template>